import { connect } from 'react-redux';
import { setModalContent } from 'redux-modules/modal';
import { setSector } from 'redux-modules/data';
import CountriesPage from 'components/data/index';
import { filterData } from 'selectors/data';

const mapStateToProps = (state) => ({
  filters: state.data.filters,
  filteredData: filterData(state)
});

const mapDispatchToProps = (dispatch) => ({
  setModalContent: (content) => dispatch(setModalContent(content)),
  setSector: (content) => dispatch(setSector(content))
});

export default connect(mapStateToProps, mapDispatchToProps)(CountriesPage);



// WEBPACK FOOTER //
// ./app/containers/data/index.js